import script from "./productAppearance.vue?vue&type=script&setup=true&lang=ts"
export * from "./productAppearance.vue?vue&type=script&setup=true&lang=ts"

import "./productAppearance.vue?vue&type=style&index=0&id=c3e7ef7e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3e7ef7e"]])

export default __exports__